import { render } from "./AccountSettingSecurityIndex.vue?vue&type=template&id=3fd238aa&scoped=true"
import script from "./AccountSettingSecurityIndex.vue?vue&type=script&lang=js"
export * from "./AccountSettingSecurityIndex.vue?vue&type=script&lang=js"

import "./AccountSettingSecurityIndex.vue?vue&type=style&index=0&id=3fd238aa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fd238aa"]])

export default __exports__